import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import Logo from 'components/logo';
import styled from 'styled-components';

const Header = () => (
  <HeaderWrapper>
    <Link to="/">
      <Logo
        type="logo"
      />
    </Link>
    <Menu aria-label="Main Navigation">
      <StyledLink to="/">home</StyledLink>
      <StyledLink to="/settings">settings</StyledLink>
      <StyledLink to="/about">about</StyledLink>
    </Menu>
  </HeaderWrapper>
);

const HeaderWrapper = memo(styled.header`
  height: 54px;
  width: 100%;
  background: ${(props) => props.theme.main.primaryHeader};
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    justify-content: space-around;
   }
`);

const Menu = memo(styled.nav`
  font-family: Roboto;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 200px;
  margin-right: 20%;
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    margin-right: unset;
   }
`);

const StyledLink = memo(styled(Link)`
 color:${(props) => props.theme.main.smallTimer};
  text-decoration: none;
  &:hover{
  color: ${(props) => props.theme.main.largeTimer};
  }
`);

export default memo(Header);
